import { render, staticRenderFns } from "./Scaffold.vue?vue&type=template&id=e4093f28&"
import script from "./Scaffold.vue?vue&type=script&lang=ts&"
export * from "./Scaffold.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports